/* Publish by EComposer at 2026-09-25 10:57:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9uh9zj38owt"]=  window.__ectimmers["ecom-9uh9zj38owt"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-9uh9zj38owt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9uh9zj38owt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-00c1381hqtg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-00c1381hqtg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vx5x4q2g4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vx5x4q2g4b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j8pja0am71n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j8pja0am71n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tpnbwnkput').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tpnbwnkput', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-la20ub57t3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-la20ub57t3s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4srdd9jc0ju').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4srdd9jc0ju', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r2s1sk98df').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r2s1sk98df', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sh8x423e6is').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sh8x423e6is', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jkc5seykr5q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jkc5seykr5q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-svplgz3iwod').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-svplgz3iwod', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rj7p30fy22').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rj7p30fy22', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1p4b1acwoot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1p4b1acwoot', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z880gslx72').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z880gslx72', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tir6xd7mkb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tir6xd7mkb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dtn6vw390fw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dtn6vw390fw', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vs4lrzt4gcr"]=  window.__ectimmers["ecom-vs4lrzt4gcr"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-vs4lrzt4gcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vs4lrzt4gcr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-quag4jfwqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-quag4jfwqd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pqrbpn9h0l8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pqrbpn9h0l8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzy41uqn7bw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzy41uqn7bw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xm5clpp99y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xm5clpp99y', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lpab5q90b8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lpab5q90b8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l932k5cdxpm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l932k5cdxpm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wd7cjnokh5k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wd7cjnokh5k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gc4pkvoz6xl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gc4pkvoz6xl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kvced19vz0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kvced19vz0a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}